module.exports = __webpack_public_path__ + "img/geodir-el-comercio-logo.ccdf984d.png";